import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class Company extends MongoEntity {
  static override _class = 'Company';
  static override _collectionName = 'companies';

  // Company identification
  @Field(() => String) debitor: Maybe<string>;
  @Field(() => String) name: Maybe<string>;

  // Business classification
  @Field(() => String) industryCode: Maybe<string>;
  @Field(() => String) industry: Maybe<string>;

  // Address information
  @Field(() => String) address: Maybe<string>;
  @Field(() => String) city: Maybe<string>;
  @Field(() => String) countryCode: Maybe<string>;

  // Tax information
  @Field(() => String) taxId: Maybe<string>;

  /**
   * SAP-Transportzone des Kunden, z. B. `DE_DD` oder `FRPO000012`. Bestimmt über den
   * Routenfahrplan, wann zu diesem Kunden gefahren wird, und damit sein Wunschlieferdatum.
   *
   * Kommt nicht aus dem Kundenstamm, sondern aus einem eigenen Export (siehe
   * `import-data/server/import-transport-zones.ts`) — deshalb kann das Feld auch bei einer
   * bekannten Firma leer sein. Leer heißt: Ersatzregel, nicht Fehler.
   */
  @Field(() => String) transportZone: Maybe<string>;

  constructor(data: Partial<Company>) {
    super(data);
    Object.assign(this, data);
  }
}
